module.exports = __webpack_public_path__ + "资讯.png?51753a7a06ea9db4eafe86fade8b3e67";


//////////////////
// WEBPACK FOOTER
// ./src/assets/资讯.png
// module id = 636
// module chunks = 0